// extracted by mini-css-extract-plugin
module.exports = {"input":"deleteGroupModal_input_1L0AZ","inputContainer":"deleteGroupModal_inputContainer_1cX1l","button":"deleteGroupModal_button_2_LMw"};